export default {
  PAGES: '/pages',
  PAGE: '/pages/{}',
  SLIDER_IMAGES: '/slider-images',
  SECURE_SLIDER_IMAGES: '/secure/slider-images',
  NEWS: '/news',
  SECURE_NEWS: '/secure/news',
  SECURE_PAGES: '/secure/pages',
  SECURE_PAGE: '/secure/pages/{}',
  LOGIN: '/auth/login',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  USER: '/secure/user',
  CHANGE_PASSWORD: '/secure/user/change-password',
  REGISTER_TO_EVENTS: '/secure/user/events/{}',
  UNSUBSCRIBE_TO_EVENT: '/secure/user/events/{}/unsubscribe',
  SUBSCRIBE_TO_EVENT: '/secure/user/events/{}/subscribe',
  ASSIGN_GROUP_ANIMATOR: '/secure/admin/events/{}/groups/animator',
  USER_EVENTS: '/secure/user/events',
  USERS: '/secure/admin/users',
  USERS_EDIT: '/secure/admin/users/{}',
  USERS_RESET_PASSWORD: '/secure/admin/users/{}/reset-password',
  EVENT_QR: '/secure/user/events/qr',
  AVAILABLE_EVENTS: '/events',
  REGISTER_USER: '/auth/register-user',
  EVENT_PAYMENTS: '/secure/admin/events/{}/payments',
  EVENT_LIST: '/secure/admin/events',
  EVENT_DETAIL: '/secure/admin/events/{}',
  VOLUNTEER_TYPES: '/secure/volunteers-types',
  TRANSPORT_TYPES: '/secure/admin/transport-types',
  EVENT_PARTICIPANTS: '/secure/admin/events/{}/participants',
  EVENT_GROUPS: '/secure/admin/events/{}/groups',
  EVENT_PARTICIPANTS_DETAIL: '/secure/admin/events/{}/participants/{}',
  EVENT_PARTICIPANTS_UNSUBSCRIBE: '/secure/admin/events/{}/participants/{}/unsubscribe',
  EVENT_PARTICIPANTS_SUBSCRIBE: '/secure/admin/events/{}/participants/{}/subscribe',
  VERIFY_EMAIL: '/auth/verify-email',

  resolveEndpoint(endpoint, params) {
    let result = endpoint;
    params.forEach((param) => {
      result = result.replace('{}', param);
    });
    return result;
  },
};
